export function normalizeThoughtDetailsArray(val) {
  if (!Array.isArray(val)) return null
  const out = []
  for (const item of val) {
    if (typeof item === 'string') {
      const t = item.trim()
      if (t) out.push(t)
    } else if (item && typeof item === 'object' && typeof item.text === 'string') {
      const t = String(item.text).trim()
      if (t) out.push(t)
    }
  }
  return out.length ? out : null
}

export function firstString(...vals) {
  for (const v of vals) {
    if (typeof v === 'string') {
      const t = v.trim()
      if (t) return t
    }
  }
  return null
}
